export function passThroughTranslation(value) {
    return {
        key: 'strings:colonistCommon.utils.#buffer',
        options: {
            value: value
        }
    };
}
